import { LicensePersonInfo } from "../../../../generated/data-contracts";

interface IAvisPersonValueProps {
  personInfo?: LicensePersonInfo;
}
export function AvisPersonValue(props: Readonly<IAvisPersonValueProps>) {
  const { personInfo } = props;

  const titleParts = [personInfo?.name, personInfo?.legalStatusName];
  const titleValue = titleParts.filter((part) => part).join(", ");

  return <span>{titleValue}</span>;
}
